import Head from 'next/head'

import * as S from './SearchGCSE.styles'

const defaultProps = {}
const propTypes = {}

export const Search = () => {
  return (
    <S.Container>
      <S.Content>
        {typeof window !== 'undefined' && (
          <>
            <Head>
              <script
                async
                src="https://cse.google.com/cse.js?cx=028315ce5e1b830ba"
              />
            </Head>
            <S.Title>Search results</S.Title>
            <div
              className="gcse-searchresults-only"
              data-refinementStyle="link"
              data-personalizedAds="false"
            />
          </>
        )}
      </S.Content>
    </S.Container>
  )
}

Search.defaultProps = defaultProps
Search.propTypes = propTypes

export default Search
